import DateFormat from "%/dynamic-components/render-engine/options/date-format";
import dayjs from "dayjs";
import { timeAgo } from "~/helpers/publication-helper";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/stores/configuration-store";

export const DateElementMixin = {
  options: [DateFormat],
  data() {
    return {
      DateFormat,
    };
  },
  computed: {
    ...mapState(useConfigurationStore, ["dateFormat"]),
  },
  methods: {
    dayjs,
    timeAgo,
    formattedDate(date) {
      const dayjsDate = dayjs.unix(date);
      let formatString = this.getOptionValue(DateFormat) ?? DateFormat.defaultValue;
      if (formatString === "global") {
        formatString = this.dateFormat?.value;
      }
      if (formatString === "timeAgo") {
        return this.timeAgo(date);
      }
      return dayjsDate.format(formatString || "MMM D, YYYY");
    },
  },
};
